var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row justify-content-center" }, [
      _c(
        "div",
        {
          staticClass:
            "col-6 col-xs-12 col-lg-6 col-md-8 justify-content-center",
        },
        [
          _c("div", { staticClass: "application-submmited-card" }, [
            _c("div", { staticClass: "col-sm-12 col-xs-12 no-padding" }, [
              _c("img", { attrs: { src: _vm.logo, alt: _vm.companyName } }),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-check-circle" }),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(_vm.t("application.submitted_title")))]),
            _vm._v(" "),
            _vm.isEnquiry
              ? _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.t("application.enquiry_submitted")),
                  },
                })
              : _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.t("application.submitted", {
                        company: _vm.companyName,
                      })
                    ),
                  },
                }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.from === "app"
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-secondary btn-md",
                    staticStyle: { width: "200px" },
                    on: { click: _vm.doneHandle },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.t("filter.done")) +
                        "\n        "
                    ),
                  ]
                )
              : _c(
                  "a",
                  { staticClass: "btn btn-secondary", attrs: { href: "/" } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.t("error.go_homepage")) +
                        "\n        "
                    ),
                  ]
                ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }